import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Globe, Check } from "lucide-react";

export default function LanguageSelector() {
  const { lang, setLang, available, t } = useI18n();
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-selector-button"
        className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm border border-border hover:bg-muted transition"
      >
        <Globe className="w-4 h-4" />
        <span className="uppercase font-semibold">{lang}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white border border-border rounded-2xl shadow-lg overflow-hidden z-50 animate-fade-up">
          {available.map((code) => (
            <button
              key={code}
              data-testid={`language-option-${code}`}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-3 text-sm hover:bg-muted ${lang === code ? "bg-muted" : ""}`}
            >
              <span>{t.languageNames[code]}</span>
              {lang === code && <Check className="w-4 h-4 text-[hsl(var(--primary-green))]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
